"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputDateMask = createInputDateMask;
exports.formatDate = formatDate;
exports.formatDateTime = formatDateTime;
exports.formatTime = formatTime;
exports.parseDate = parseDate;
exports.parseTime = parseTime;
exports.ticksToDateString = ticksToDateString;
var _config = _interopRequireDefault(require("../config"));
var _dateFns = require("date-fns");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * converts .NET ticks to UTC timestamp
 */
function ticksToDateString(ticks) {
  if (typeof ticks !== 'number') return false;
  if (ticks === 0) return 'N/A';
  var ticksSinceEpoch = ticks - 621355968000000000;
  var millisecondsSinceEpoch = ticksSinceEpoch / 10000;
  var date = new Date(millisecondsSinceEpoch);
  return formatDateTime(date);
}

// Formats supported are any ordering of M/MM, d/dd and yyyy with -, /, or . separators.
function parseDate(dateString) {
  if (dateString.length === 0) {
    return '';
  }
  var dateFormat = _config["default"].global.dateFormat;
  var regex = /[^.\-/]+/g;
  var keys = dateFormat.match(regex);
  var parsed = dateString.match(regex);
  var dateObj = {};
  keys.forEach(function (key, index) {
    // Normalize to uppercase for consistent access
    dateObj[key.charAt(0).toUpperCase()] = parseInt(parsed[index], 10);
  });
  return new Date(dateObj['Y'], dateObj['M'] - 1, dateObj['D']);
}
function parseTime(timeArg) {
  if (!timeArg) return;
  if ((0, _dateFns.isDate)(timeArg)) return timeArg;
  var _timeArg$split = timeArg.split(' '),
    _timeArg$split2 = _slicedToArray(_timeArg$split, 2),
    time = _timeArg$split2[0],
    amPm = _timeArg$split2[1];
  var _time$split = time.split(':'),
    _time$split2 = _slicedToArray(_time$split, 2),
    hours = _time$split2[0],
    minutes = _time$split2[1];
  if (amPm && amPm.toLowerCase() === 'pm') {
    hours = +hours + 12;
  }
  return new Date(0, 0, 0, +hours, +minutes);
}
function formatDate(date, customFormat) {
  if (date === '' || date === null || date === undefined) {
    return '';
  }
  var dateObj = (0, _dateFns.isDate)(date) ? date : new Date(date);
  if (!(0, _dateFns.isValid)(dateObj)) {
    return '';
  }
  return (0, _dateFns.format)(dateObj, customFormat || _config["default"].global.dateFormat);
}
function formatTime(time) {
  if (time === '' || time === null || time === undefined) {
    return '';
  }
  var timeObj = (0, _dateFns.isDate)(time) ? time : new Date(time);
  if (!(0, _dateFns.isValid)(timeObj)) {
    return '';
  }
  return (0, _dateFns.format)(timeObj, _config["default"].global.timeFormat);
}
function formatDateTime(dateTime) {
  if (dateTime === '' || dateTime === null || dateTime === undefined) {
    return '';
  }
  var dateTimeObj = (0, _dateFns.isDate)(dateTime) ? dateTime : new Date(dateTime);
  if (!(0, _dateFns.isValid)(dateTimeObj)) {
    return '';
  }
  return (0, _dateFns.format)(dateTimeObj, _config["default"].global.dateTimeFormat);
}
function createInputDateMask() {
  // Divide dateFormat to groups like [M/,d/,yyyy]
  var formatMask = '',
    inputMask = '';
  var separator = _config["default"].global.dateFormat.match(/(\W)/g)[0];
  var reg = new RegExp("([A-Za-z]+".concat(separator, ")([A-Za-z]+").concat(separator, ")([A-Za-z]+)"));
  var regArray = _config["default"].global.dateFormat.match(reg);
  var maxGroupsSize = 3;
  for (var i = 1; i <= maxGroupsSize; i++) {
    if (regArray[i].length === 2 && regArray[i].match("".concat(separator))) {
      // Check option like M/ and replace with MM/
      formatMask += regArray[i].slice(0, -1) + regArray[i];
    } else if (regArray[i].length === 1) {
      formatMask += regArray[i].repeat(2);
    } else {
      formatMask += regArray[i];
    }
  }

  // Replace all symbols to 9
  inputMask = formatMask.replace(/[A-Za-z]/g, '9');
  // Return both: displayMask (uppercase for placeholder) and formatMask (for date-fns formatting)
  return {
    inputMask: inputMask,
    formatMask: formatMask,
    displayMask: formatMask.toUpperCase()
  };
}